import { request } from '../../../gateways/api'
import type { Project } from '../types/Project'

export { fetchProject }

const fetchProject = async ({ id }: { id: string }): Promise<Project> => {
  const result = await request({
    url: `/rest/project/${id}`,
    method: 'GET',
  })

  return result
}
